/* eslint-disable no-bitwise */
export interface IMessageModel {
    severity: MessageSeverity;
    message: string;
    anchor: string;
    anchorText?: string;
    code?: string;
    priority?: number;
    metadata?: { [key: string]: string };
    validationScope?: number;
}

export interface IMessageLabel {
    severity: MessageSeverity;
    labelText: string;
}

export enum MessageSeverity {

    Critical = 0,

    Error = 1,

    Warning = 2,

    Update = 3,

    Info = 4
}

export enum AlertValidationScopes {
    okand = 0,
    inget = 1 << 0,
    skickaTillViol2 = 1 << 1,
    skickaTillViol3 = 1 << 2,
    skickaTillViol = AlertValidationScopes.skickaTillViol2 | AlertValidationScopes.skickaTillViol3
}
